module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main",
    attrs: {
      "cclass": "fullscreen appearing main global--background"
    }
  }, [_c('div', {
    staticClass: "main-container",
    class: {
      'white-background': _vm.isConnection, 'black-background': _vm.isSignUp
    },
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'black-color': _vm.isConnection, 'white-color': _vm.isSignUp
    }
  }, [_vm._v("\n         " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.isConnection) ? _c('v-text-field', {
    attrs: {
      "name": "username",
      "label": "Identifiant",
      "rules": _vm.usernameRules,
      "dark": _vm.isSignUp,
      "required": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isConnection) ? _c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Mot de passe",
      "autocomplete": "new-password",
      "rules": _vm.passwordRules,
      "required": "",
      "append-icon": _vm.hiddenPassword ? 'visibility' : 'visibility_off',
      "type": _vm.hiddenPassword ? 'password' : 'text'
    },
    on: {
      "click:append": function () { return (_vm.hiddenPassword = !_vm.hiddenPassword); }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "name": "username_signup",
      "label": "Identifiant",
      "rules": _vm.usernameRules,
      "dark": "",
      "required": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "email",
      "label": "email",
      "rules": _vm.emailRules,
      "autocomplete": "new-password",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "first_name",
      "label": "Prénom",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = $$v
      },
      expression: "first_name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "last_name",
      "label": "Nom",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.last_name),
      callback: function($$v) {
        _vm.last_name = $$v
      },
      expression: "last_name"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSignUp) ? _c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "tag",
      "label": "Tag",
      "dark": "",
      "required": ""
    },
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submit-block"
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.valid,
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.debouncedSubmit
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "err-msg"
  }, [_vm._v("\n         " + _vm._s(_vm.errMsg) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password-block"
  }, [(_vm.isConnection) ? _c('a', {
    staticClass: "forgot-password connection",
    attrs: {
      "href": "/forgot_password"
    }
  }, [_vm._v("\n            Mot de passe oublié ?\n         ")]) : _vm._e()])], 1), _vm._v(" "), (_vm.platform === 'shdl' || !_vm.isProduction) ? _c('div', {
    staticClass: "sign-up-block"
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.onModeButtonTap
    }
  }, [_vm._v(_vm._s(_vm.modeButtonText))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480f9e4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = 1186
// module chunks = 1